import type { Messages } from '@/i18n/messages'

import { fmt } from '@/i18n/plural'

const MAP: Record<string, keyof Messages['errors']> = {
    required: 'required',
    invalid_email: 'invalidEmail',
    invalid_name: 'invalidName',
    invalid_nationality: 'invalidNationality',
    phone_country: 'phoneCountry',
    invalid_phone: 'invalidPhone',
    password_short: 'passwordShort',
    password_weak: 'passwordWeak',
    password_mismatch: 'passwordMismatch',
    email_taken: 'emailTaken',
    invalid_credentials: 'invalidCredentials',
    social_account: 'socialAccount',
    rate_limited: 'rateLimited',
    captcha_failed: 'captchaFailed',
    security_pending: 'securityPending',
    provider_unavailable: 'providerUnavailable',
    oauth_failed: 'oauthFailed',
    invalid_code: 'invalidCode',
    code_attempts: 'codeAttempts',
    wrong_password: 'wrongPassword',
    invalid_mtcn: 'invalidMtcn',
    mtcn_mismatch: 'mtcnMismatch',
    screenshot_required: 'screenshotRequired',
    screenshot_type: 'screenshotType',
    screenshot_size: 'screenshotSize',
    terms_required: 'termsRequired',
    not_available: 'notAvailable',
    too_many_guests: 'tooManyGuests',
    invalid_stay: 'invalidStay',
    network: 'network'
}

export const errorText = (m: Messages, code: string | undefined | null, values: Record<string, string> = {}): string => {
    const key = code ? MAP[code] : undefined

    return fmt(key ? m.errors[key] : m.errors.generic, values)
}
